import React from 'react'

const MobileFiltersTags = () => {
	return (
		<div>
			<div className='mb-3'>
				<h5 className='text-normal text-black'>Tags</h5>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Best Price <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Special Deals <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Festive Offers <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						New Arrivals <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Special Discounts <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Best Seller <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						New Arrivals <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
			<div>
				<div class='form-check p-0 mb-2'>
					<input class='form-check-input' type='checkbox' value='' id='fcustomCheck1' unchecked='' />
					<label class='custom-control-label ms-3' for='customCheck1'>
						Clearence Sale <small className='text-dark ms-1'>(10,000)</small>
					</label>
				</div>
			</div>
		</div>
	)
}

export default MobileFiltersTags
